import ApproveCurriculumPage from "./ApproveCurriculumPage";

export default ApproveCurriculumPage;